import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.closeOnEscape = this.closeOnEscape.bind(this)
    document.addEventListener("keydown", this.closeOnEscape)
    this.focusEditor()
  }

  disconnect() {
    document.removeEventListener("keydown", this.closeOnEscape)
  }

  closeOnEscape(event) {
    if (event.key !== "Escape" || !this.element.hasAttribute("open")) return

    event.preventDefault()
    event.stopPropagation()
    this.close()
  }

  close() {
    this.element.close?.()
    this.element.removeAttribute("open")
  }

  focusEditor() {
    const editor = this.element.querySelector("[contenteditable]")
    if (!editor) return

    editor.focus()
    const range = document.createRange()
    range.selectNodeContents(editor)
    const selection = window.getSelection()
    selection.removeAllRanges()
    selection.addRange(range)
  }
}
